export const DEFAULT_MESSAGE = {
  title: 'Novedades Habitat 99',
  body: '',
  emphasis: 'regular',
};

export const DEFAULT_FILTERS = {
  audienceScope: 'all',
  groups: [],
  contracts: [],
  ownership: 'all',
};

export const EMOJI_PRESETS = ['🚀', '🏡', '✨', '📢', '🤝', '⏰', '🛠️', '💡'];

export const GROUP_OPTIONS = [
  { id: 'premium', label: 'Planes premium', description: 'Suscriptores premium y preferenciales' },
  { id: 'regular', label: 'Planes regulares', description: 'Planes estándar activos' },
  { id: 'delinquent', label: 'Con mora', description: 'Suscriptores con deuda o atraso' },
  { id: 'lead', label: 'Interesados', description: 'Leads o consultas recientes' },
];

export const CONTRACT_OPTIONS = [
  { id: 'H99-001', label: 'H99-001 - Torre Norte' },
  { id: 'H99-014', label: 'H99-014 - Torre Sur' },
  { id: 'H99-032', label: 'H99-032 - Torres Lago' },
  { id: 'H99-048', label: 'H99-048 - Housing Río' },
];

export const OWNERSHIP_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'owner', label: 'Poseedor' },
  { value: 'nonOwner', label: 'No poseedor' },
];

export const EMPHASIS_WEIGHTS = {
  light: 400,
  regular: 500,
  bold: 700,
};
